import type { ReactNode } from 'react'

export const LOGO_SRC = `${import.meta.env.BASE_URL}ovo-logo.png`

export function Logo({ size = 44 }: { size?: number }) {
  return <img src={LOGO_SRC} alt="" width={size} height={Math.round(size * 1.26)} draggable={false} />
}

interface EmptyStateProps {
  title: string
  text?: ReactNode
  action?: ReactNode
}

/** Пустое состояние с логотипом OVO в «скруглённом квадрате». */
export function EmptyState({ title, text, action }: EmptyStateProps) {
  return (
    <div className="empty">
      <div className="empty__logo">
        <Logo />
      </div>
      <div className="empty__title">{title}</div>
      {text && <div className="empty__text">{text}</div>}
      {action}
    </div>
  )
}

/** Ошибка загрузки с повтором. */
export function ErrorState({ text, onRetry }: { text: string; onRetry?: () => void }) {
  return (
    <div className="empty">
      <div className="empty__logo">
        <Logo />
      </div>
      <div className="empty__title">Не получилось загрузить</div>
      <div className="empty__text">{text}</div>
      {onRetry && (
        <button type="button" className="btn btn--secondary" onClick={onRetry}>
          Повторить
        </button>
      )}
    </div>
  )
}
